import React, { useMemo } from 'react';
import { identity } from 'lodash';
import PERFORMANCE_RECOMMENDATIONS from 'modules/campaigns/modules/performance-recommendations/config/performanceRecommendations';
import { useRecommendationService } from 'modules/campaigns/modules/performance-recommendations/hooks/useRecommendationService';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedRelativeTime } from '../../../../../modules/taboola-common-frontend-modules/i18n';
import { NotificationCard } from '../../NotificationCard';
import { truncateTargetName } from '../../utils';

export const UnblockSitesNotification = ({ notification, timeDiffInMinutes, closeNotificationCenter }) => {
    const {
        attributes: { recommendationTargetName, recommendationTargetId: campaignId },
        referredEntityId,
    } = notification;

    const { id: accountId } = useAccount();

    const { editCampaignWithRecommendation: onCardClick } = useRecommendationService();

    const finalRecommendationTargetName = useMemo(
        () => truncateTargetName(recommendationTargetName),
        [recommendationTargetName]
    );

    return (
        <NotificationCard
            notification={notification}
            cardClick={onCardClick}
            cardClickParams={{
                recommendation: {
                    type: PERFORMANCE_RECOMMENDATIONS.UNBLOCK_SITES,
                    id: referredEntityId,
                },
                recommendationData: { campaignTargeting: { publisherTargeting: { exclude: identity } } },
                accountId,
                campaignId,
            }}
            closeNotificationCenter={closeNotificationCenter}
            dataMetricsComponent="NotificationActionCard"
            formattedMessageId="app.notificationsCenter.recommendationCampaignTargetDetails"
            formattedMessageValues={{
                recommendationTargetName: finalRecommendationTargetName,
                recommendationTargetId: campaignId,
                notificationTimeAgo: <FormattedRelativeTime timeDiffInMinutes={timeDiffInMinutes} />,
            }}
        />
    );
};
